// Merchant fields only a full admin may change. A menuAdmin can maintain the rest of
// the merchant record, but billing/commercial rates, the restaurant identity, the
// platform kill-switch and who administers the restaurant stay admin-only.
// Mirrors ADMIN_ONLY_RESTAURANT_FIELDS in the server's editRestaurant handler, which
// strips these from any non-admin request - keep the two lists in sync.
const ADMIN_ONLY_RESTAURANT_FIELDS = [
  'urlIdentifier',
  'restaurantAdmin',
  'serviceMonthlyPrice',
  'applicationFee',
  'onlinePaymentSurchargeRate',
  'inPersonPaymentSurchargeRate',
  'stripeFeeOnUs',
  'disableOnlineSurcharge',
  'deliveryServiceOnlineRate',
  'deliveryServiceCommissionRate',
  'deliveryServiceCommissionDiscount',
  'isClosed',
  'terminalProvider',
];

// Drops the fields the API will strip anyway, so a menuAdmin's save never looks like
// it persisted something it did not. The server remains the authority.
const omitAdminOnlyFields = (formRequest) => {
  const allowed = { ...formRequest };
  ADMIN_ONLY_RESTAURANT_FIELDS.forEach((field) => delete allowed[field]);
  return allowed;
};

export { ADMIN_ONLY_RESTAURANT_FIELDS, omitAdminOnlyFields };
